export default __webpack_public_path__ + "static/media/9831fb97-1e62-453a-a652-3b5c7057db9f.0c0a7d37.jpg";